import script from "./TaziyeScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./TaziyeScreen.vue?vue&type=script&setup=true&lang=js"

import "./TaziyeScreen.vue?vue&type=style&index=0&id=2bbffbca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bbffbca"]])

export default __exports__